import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import TokenManager from '../utils/tokenManager';

const Callback: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  const handleCallback = useCallback(async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      
      if (!code) {
        setStatus('error');
        return;
      }

      const apiUrl = getApiUrl();
      const response = await axios.post(`${apiUrl}/oauth/response-code`, {
        code: code
      });

      if (response.data.success && response.data.tokens) {
        TokenManager.getInstance().setTokens(response.data.tokens);
        setStatus('success');
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('OAuth callback error:', error);
      setStatus('error');
    }
  }, []);

  useEffect(() => {
    handleCallback();
  }, [handleCallback]);

  const getApiUrl = () => {
    if (process.env.REACT_APP_API_BASE_URL) {
      return process.env.REACT_APP_API_BASE_URL;
    }
    
    const environment = process.env.REACT_APP_ENVIRONMENT || 'dev';
    const applicationName = process.env.REACT_APP_APPLICATION_NAME || 'servicecatalog';
    const domain = process.env.REACT_APP_DOMAIN || 'locomotive10.com';
    
    return `https://api.${environment}.${applicationName}.${domain}`;
  };

  if (status === 'loading') {
    return <div>Processing authentication...</div>;
  }

  if (status === 'success') {
    return <div>Authentication successful! Redirecting...</div>;
  }

  return <div>Authentication failed. Please try again.</div>;
};

export default Callback;